import React from 'react';

interface InputMaxLimitProps {
  value: number;
  max: number;
}

const InputMaxLimit: React.FC<InputMaxLimitProps> = (props) => {
  return (
    <>
      <span className="spaui-input-feedback-count">{props.value || 0}</span>
      <span className="spaui-input-feedback-divider">/</span>
      <span className="spaui-input-feedback-range">{props.max}</span>
    </>
  );
};

export default InputMaxLimit;
